<template>
  <v-container
    class="greenprint-section-wrapper"
    fluid
    :style="{
      'background-color': data.color,
    }"
  >
    <v-row>
      <v-col class="col-12 col-md-3 image-wrapper" offset-md="1">
        <img :src="data.image" alt="Greenprint" />
      </v-col>
      <v-col class="col-12 col-md-7 text-wrapper">
        <h2 v-html="data.title"></h2>
        <p v-html="data.text"></p>
        <template v-if="Array.isArray(data.button) === true">
          <a
            v-for="(button, i) in data.button"
            :key="i"
            :href="button.url"
            :target="button.external_url === true ? '_blank' : '_self'"
            :style="{ background: button.color ? button.color : '' }"
            class="button multi"
            >{{ button.text }}</a
          >
        </template>
        <template v-else>
          <a
            v-if="
              data.button.smooth_scroll === true ||
              data.button.smooth_scroll_custom === true
            "
            :href="data.button.url"
            :target="data.button.external_url === true ? '_blank' : '_self'"
            :style="{ background: data.button.color ? data.button.color : '' }"
            class="button"
            @click="scrollToForm"
            >{{ data.button.text }}</a
          >
          <a
            v-else
            :href="data.button.url"
            :target="data.button.external_url === true ? '_blank' : '_self'"
            :style="{ background: data.button.color ? data.button.color : '' }"
            class="button"
            >{{ data.button.text }}</a
          >
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'CommonSectionBusinesses',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  beforeMount() {},
  mounted() {},
  methods: {
    scrollToForm() {
      if (this.data.button.smooth_scroll_custom) {
        this.$vuetify.goTo(
          document.querySelector(`.${this.data.button.scroll_to_section}`)
            .offsetTop - document.getElementById('navbar').offsetHeight,
        );
      } else {
        this.$vuetify.goTo(
          document.querySelector('.form-section-wrapper').offsetTop -
            document.getElementById('navbar').offsetHeight,
        );
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.greenprint-section-wrapper
  padding: 70px 12px
  .image-wrapper
    position: relative
    display: block
    img
      display: block
      max-width: 100%
  .text-wrapper
    h2
      font-family: 'metropolisbold'
      font-style: normal
      font-weight: 700
      font-size: 48px
      color: #003036
      line-height: 1
      margin-bottom: 40px
      ::v-deep
        span
          font-family: 'metropolisregular'
          font-weight: 400
    p
      font-family: 'metropolisregular'
      font-style: normal
      font-weight: 400
      font-size: 18px
      line-height: 1.4
      color: #003036
      text-align: justify
      margin-bottom: 30px
      ::v-deep
        span
          font-family: 'metropolisbold'
          font-style: normal
          font-weight: 700
    .button
      background: #003036
      display: inline-block
      font-family: 'metropolisbold'
      font-weight: 700
      font-size: 16px
      color: #ffffff
      line-height: 1
      text-transform: uppercase
      text-align: center
      outline: none
      text-decoration: none
      padding: 12px 48px
      border-radius: 20px
      transition: all 300ms ease-in-out
      &:hover
        background: #3DCF8E
        transition: all 300ms ease-in-out
      &.multi
        margin-right: 20px
  @media screen and (max-width: 959px)
    .image-wrapper
      display: flex
      justify-content: center
      align-items: center
</style>
